<template>
	<div>
		<div class="head">
			<div class="head_con">
				<div class="search_box">
					<i class="search_icon"></i>
					<input type="search" v-model="keyword" @search='search' name="" placeholder="输入你想搜索的内容">
				</div>

				<a @click="toUrl" class="user_link"></a>
			</div>
		</div>
		<div class="act_nav">
			<ul>
				<li :class="current==index?'active':''" @click='change(index)' v-for="(item,index) in list"
					:key="index">
					<a>
						{{item.type}}
					</a>
				</li>
			</ul>
		</div>
		<div class="list">
			<div class="item" @click="toVideo(item)" v-for="(item,index) in liveList" :key="index">
				<a>
					<div class="item_pic">
						<img :src="item.imageUrl"></img>
						<span v-if="item.bookTag == 1" class="tag yyy">
							已预约
						</span>
						<span class="tag"
							:class="item.status == 0?'zzzb':item.status == 1?'zzzb':item.status == 3?'hfz':item.status == -1?'yjs':item.status == 4?'hfz':''">{{item.status == 0?'未开始':item.status == 1?'直播中':item.status == 3?'回看生成中':item.status == -1?'已结束':item.status == 4?'回看中':''}}</span>
						<div @click.stop="collectLive(item)"
							:class="(item.collectTag  == 0 || item.collectTag  == null)?'like':'liked'"></div>
					</div>
					<div class="item_title">{{item.title}}</div>
					<div class="item_time">直播时间：{{item.livetime}}
						<div v-if="item.status != 1 && item.status != -1 &&item.status != 3 && item.status != 4">
							<button @click.stop="reserveLive(item)" v-if="item.bookTag == 0 || item.bookTag == null"
								type="button" class="yy_btn">点击预约</button>
							<button v-else @click.stop="reserveLive(item)" type="button" class="yy_btn">取消预约</button>
						</div>
					</div>
				</a>
			</div>
		</div>
		<!-- 加载更多 -->
		<div class="loading" v-if="liveList.length > 0 && page > 2">
			<div class="loadingIcon" v-if="status != '我是有底线的'">
				<van-loading size="24" />
			</div>
			<div class="noData">{{status}}</div>
		</div>
		<div class="empty" v-if="liveList.length == 0">
			<van-empty image-size="120" description="暂无数据" />
		</div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import {
		Toast
	} from 'vant';
	Vue.use(Toast);
	import {
		getLiveRoomType,
		getLiveList,
		bookRoom,
		collectRoom
	} from '@/request/api.js'
	import {
		checkAuthonToken
	} from '@/request/http.js'
	import {
		onLogin,
		getUrlSearch
	} from '@/utils/thread.js'
	export default {
		data() {
			return {
				title: '',
				keyword: null,
				list: [{
					type: '全部活动'
				}],
				current: 0,
				liveList: [],
				status: '加载中',
				page: 1,
				authToken: localStorage.getItem('authToken') == 'undefined' ? null : localStorage.getItem('authToken')
			}
		},
		created() {
			var timer;
			var flag = true;
			window.addEventListener('scroll', () => {
				if (flag) {
					this.status = '加载更多';
					this.getLiveList(this.list[this.current].id)
				}
				flag = false;
				clearTimeout(timer);
				timer = setTimeout(() => {
					flag = true
				}, 500);
			}, true);
		},
		destroyed() {
			window.removeEventListener('scroll', this.scrollBottom) //页面离开后销毁监听事件
		},
		mounted() {
			console.log(this.$route.query.token)
			if (this.$route.query.token) {
				localStorage.setItem('authToken', this.$route.query.token)
				this.authToken = localStorage.getItem('authToken')
			}
			this.getLiveRoomType()
		},
		methods: {
			//滑动到底部
			scrollBottom() {
				setTimeout(() => {
					let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
					let clientHeight = document.documentElement.clientHeight;
					let scrollHeight = document.documentElement.scrollHeight;
					if (scrollTop + clientHeight + 30 >= scrollHeight) {
						this.status = '加载更多';
						this.getLiveList(this.list[this.current].id)
					}
				}, 1000)
			},
			//搜索
			search() {
				this.page = 1
				this.liveList = []
				this.status = '加载中'
				this.getLiveList(this.list[this.current].id)
			},
			collectionLiveApi(item) {
				collectRoom({
					bookTag: item.bookTag,
					collectTag: item.collectTag == 0 ? 1 : 0,
					roomId: item.id,
					token: this.authToken
				}).then(res => {
					if (res.status == 200) {
						if (item.collectTag == 0) {
							item.collectTag = 1
						} else {
							item.collectTag = 0
						}
					} else {
						Toast('操作失败,请稍后重试');
					}
				}).catch(e => {
					Toast('网络错误');
				})
			},
			//收藏直播
			collectLive(item) {
				checkAuthonToken()
					.then(res => {
						this.collectionLiveApi(item)
					}).catch(e => {
						if (!e) {
							onLogin()
						}
					})
			},
			//预约直播
			reserveLiveApi(item) {
				bookRoom({
					bookTag: item.bookTag == 0 ? 1 : 0,
					collectTag: item.collectTag,
					roomId: item.id,
					token: this.authToken
				}).then(res => {
					if (res.status == 200) {
						if (item.bookTag == 0) {
							item.bookTag = 1
						} else {
							item.bookTag = 0
						}
					} else {
						Toast('预约失败,请稍后重试');
					}
				}).catch(e => {
					Toast('网络错误');
				})
			},
			//预约直播
			reserveLive(item) {
				checkAuthonToken()
					.then(res => {
						this.reserveLiveApi(item)
					}).catch(e => {
						onLogin()
					})
			},
			//观看直播
			toVideo(item) {
				window.location.href = 'https://live.cacpaper.com/#/live/home?roomId=' + item.id
			},
			//获取直播分类
			getLiveRoomType() {
				getLiveRoomType().then(res => {
						if (res.status == 200) {
							this.list = this.list.concat(res.data.data)
							this.getLiveList(this.list[0].id)
						} else {
							Toast('直播分类获取失败');
						}
					})
					.catch(e => {
						Toast('网络错误')
					});
			},
			//直播列表
			getLiveList(type) {
				let that = this
				checkAuthonToken()
					.then(res => {
						getLiveList({
								type: type,
								page: that.page,
								size: 10,
								title: that.keyword,
								token: that.authToken
							}).then(res => {
								if (res.status == 200) {
									let data = res.data.data.data
									that.page += 1
									if (data.length > 0) {
										that.liveList = that.liveList.concat(data)
									} else {
										that.status = '我是有底线的'
										window.removeEventListener('scroll', this.scrollBottom)
									}
								} else {
									Toast('直播列表获取失败');
								}
							})
							.catch(e => {
								Toast('网络错误')
							});
					}).catch(e => {
						if (!e) {
							getLiveList({
									type: type,
									page: that.page,
									size: 10,
									title: that.keyword
								}).then(res => {
									if (res.status == 200) {
										let data = res.data.data.data
										if (data.length > 0) {
											that.page += 1
											that.liveList = that.liveList.concat(data)
										} else {
											that.status = '我是有底线的'
											window.removeEventListener('scroll', this.scrollBottom)
										}
									} else {
										Toast('直播列表获取失败');
									}
								})
								.catch(e => {
									Toast('网络错误')
								});
						}
					})
			},
			change(index) {
				this.current = index;
				this.page = 1
				this.liveList = []
				this.status = '加载中'
				this.getLiveList(this.list[index].id)
			},
			toUrl() {
				checkAuthonToken()
					.then(res => {
						this.$router.push({
							path: '/my',
							params: {
								source: 1
							}
						})
					}).catch(e => {
						onLogin()
					})
			},
		}
	}
</script>

<style>
	@import '../../utils/main.css';

	#app {
		margin: 0 auto;
		max-width: 800px;
	}

	.empty {
		display: flex;
		justify-content: center;
		text-align: center;
	}

	input[type="search"] {
		-webkit-appearance: none;
	}

	input::-webkit-search-cancel-button {
		display: none;
	}
</style>
